const axios = require('axios');

const Upload = async function(key, type, base64data, cb) {

  let randomKey = `${Date.now().toString(36)}${key}`;

  try {
    let response = await axios
    .post(window.ENDPOINT,
      {
        query: `
                  mutation {
                      uploadFile(base64: "${base64data}", type: "${type}", key: "${randomKey}")
                  }
                `,
        variables: null
      },
      {
        headers: {
          Authorization: localStorage.getItem("gevme_token")
        }
      }
    );
    if (response.data) {
      cb(response.data.data.uploadFile.Location);
    }
  } catch (err) {
    console.log(err);
  }
};

export default Upload;



// WEBPACK FOOTER //
// ./src/ext/upload.js